export default __webpack_public_path__ + "static/media/login_graphic.d96d6770.svg";